<template>
  <div class="home-elements">
    <fcwpHomePoster
      v-if="poster"
      :poster="poster"
    ></fcwpHomePoster>
    <fcwpHomeMenu
      v-if="menu"
      :menu="menu"
    ></fcwpHomeMenu>
  </div>
</template>

<script>
import fcwpHomePoster from "./home/fcwpHomePoster.vue";
import fcwpHomeMenu from "./home/fcwpHomeMenu.vue";

export default {
  name: "fcwpHeader",
  props: ["menu", "poster"],
  components: {
    fcwpHomePoster,
    fcwpHomeMenu
  }
};
</script>

<style lang="scss">
.home-elements {
  background: rgb($tertiary-color);
  border: 1.17vw solid rgb($quaternary-color);
  border-top: 0;
}

</style>